/* Qalbeen · HOVER : apparition au défilement, tiroirs, bandeau d'annonces, barres collantes, carrousels.
   Sans jQuery, chargé en defer. Fonctionne aussi dans l'éditeur de thème (sections rechargées). */
(function () {
  var D = document, R = D.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editeur = !!(window.Shopify && Shopify.designMode);
  R.classList.add('hv-js');
  var $$ = function (s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); };

  /* apparition : .hv-rv, .hv-rv-fade, .hv-ink, [data-hv-reveal] reçoivent .vu à l'entrée dans l'écran */
  var io = ('IntersectionObserver' in window && !reduce && !editeur) ? new IntersectionObserver(function (en) {
    en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vu'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;
  function reveal(c) { $$('.hv-rv, .hv-rv-fade, .hv-ink, [data-hv-reveal]', c).forEach(function (el) { if (el.classList.contains('vu')) return; if (io) io.observe(el); else el.classList.add('vu'); }); }

  /* tiroirs : bouton [data-hv-open="id"], fermeture [data-hv-close], voile .hv-veil, touche Échap */
  var ouvert = null, retour = null;
  function veil() { return D.querySelector('[data-hv-veil]'); }
  function ouvrir(id, btn) {
    var d = D.getElementById(id); if (!d) return;
    fermer(); ouvert = d; retour = btn || D.activeElement;
    d.classList.add('on'); d.setAttribute('aria-hidden', 'false');
    var v = veil(); if (v) v.classList.add('on');
    R.classList.add('hv-lock');
    $$('[data-hv-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = d.querySelector('[data-hv-close], a, button'); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function fermer() {
    if (!ouvert) return;
    var id = ouvert.id; ouvert.classList.remove('on'); ouvert.setAttribute('aria-hidden', 'true');
    var v = veil(); if (v) v.classList.remove('on');
    R.classList.remove('hv-lock');
    $$('[data-hv-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    ouvert = null; if (retour && retour.focus) retour.focus();
  }
  D.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-hv-open]');
    if (o) { e.preventDefault(); ouvrir(o.getAttribute('data-hv-open'), o); return; }
    if (e.target.closest && (e.target.closest('[data-hv-close]') || e.target.closest('[data-hv-veil]'))) { e.preventDefault(); fermer(); }
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); });

  /* bandeau d'annonces : messages .hv-ann__m qui tournent */
  function annonces(c) {
    $$('[data-hv-ann]', c).forEach(function (a) {
      if (a._hv) return; a._hv = 1;
      var ms = $$('.hv-ann__m', a), i = 0, t = (+a.getAttribute('data-hv-ann') || 4) * 1000;
      if (ms.length < 2 || reduce) return;
      setInterval(function () { if (D.hidden) return; ms[i].classList.remove('on'); i = (i + 1) % ms.length; ms[i].classList.add('on'); }, t);
    });
  }

  /* hauteur de l'en-tête dans --hv-hd-h (pour les éléments collants sous l'en-tête) */
  function hauteur() {
    var h = D.querySelector('.hv-hd'); if (!h) return;
    var maj = function () { R.style.setProperty('--hv-hd-h', h.offsetHeight + 'px'); };
    maj(); if ('ResizeObserver' in window) new ResizeObserver(maj).observe(h);
  }

  /* barre collante : <div class="hv-sticky" data-hv-sticky="#bouton-achat"> visible quand la cible est passée au-dessus de l'écran.
     La position est vérifiée au chargement, au défilement et après un saut d'ancre (#avis…) : un saut qui passe
     d'« en dessous » à « au-dessus » de l'écran ne croise jamais l'écran, l'IntersectionObserver seul ne le voit pas.
     Même règle que hover-product.js (bas du bouton au-dessus de l'écran) : les deux peuvent tourner ensemble. */
  var barres = [];
  function majBarres() {
    barres = barres.filter(function (b) { return b.st.isConnected && b.cible.isConnected; });
    barres.forEach(function (b) {
      var v = b.cible.getBoundingClientRect().bottom < 0;
      if (b.st.classList.contains('on') === v) return;
      b.st.classList.toggle('on', v); D.body.classList.toggle('hv-has-sticky', v); b.st.setAttribute('aria-hidden', String(!v));
    });
  }
  var rqB = null;
  function planBarres() { if (rqB) return; rqB = requestAnimationFrame(function () { rqB = null; majBarres(); }); }
  window.addEventListener('scroll', planBarres, { passive: true });
  window.addEventListener('resize', planBarres);
  window.addEventListener('hashchange', function () { setTimeout(majBarres, 60); });
  window.addEventListener('load', function () { majBarres(); setTimeout(majBarres, 400); });
  function collantes(c) {
    $$('[data-hv-sticky]', c).forEach(function (st) {
      if (st._hvSt) return;
      var cible = D.querySelector(st.getAttribute('data-hv-sticky'));
      if (!cible) return;
      st._hvSt = 1; barres.push({ st: st, cible: cible });
      if ('IntersectionObserver' in window) new IntersectionObserver(planBarres).observe(cible);
    });
    majBarres();
  }

  /* carrousels : boutons [data-hv-prev] / [data-hv-next] avec data-hv-rail="#id" */
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-hv-prev],[data-hv-next]'); if (!b) return;
    var r = D.querySelector(b.getAttribute('data-hv-rail')); if (!r) return;
    var c = r.firstElementChild, pas = c ? c.getBoundingClientRect().width + 16 : r.clientWidth * .8;
    r.scrollBy({ left: b.hasAttribute('data-hv-prev') ? -pas : pas, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* lueur dorée qui suit le pointeur sur les boutons */
  D.addEventListener('pointermove', function (e) {
    var b = e.target.closest && e.target.closest('.hv-btn,.hv-bloom'); if (!b) return;
    var r = b.getBoundingClientRect(); b.style.setProperty('--x', (e.clientX - r.left) + 'px'); b.style.setProperty('--y', (e.clientY - r.top) + 'px');
  }, { passive: true });

  /* compteur du panier : petit rebond quand le panier change (événement de Dawn) */
  if (window.subscribe && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    setTimeout(function () { $$('.hv-cnt').forEach(function (c) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }); }, 300);
  });

  function init(c) { reveal(c); annonces(c); collantes(c); }
  window.HoverQalbeen = { init: init, ouvrir: ouvrir, fermer: fermer };
  init(D); hauteur();
  D.addEventListener('shopify:section:load', function (e) { init(e.target); hauteur(); });
})();
